const customEvents = new EventTarget();

export default customEvents;